import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { useGetDetailedUser } from '@/generated/client/users/users';

import { userAccessRoutes } from '../../utils/userAccessRoutes';
import { UserAccessHeader } from '../user-access-header/UserAccessHeader';
import { UserAccessErrorState } from '../user-access-state-panel/UserAccessErrorState';
import { UserAccessLoadingState } from '../user-access-state-panel/UserAccessLoadingState';
import { UserDetailsContent } from './UserDetailsContent';

type UserDetailsViewProps = {
  userId: number;
};

export function UserDetailsView({ userId }: UserDetailsViewProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const detailsQuery = useGetDetailedUser({ userid: userId });
  const details = detailsQuery.data?.data;
  const header = (
    <UserAccessHeader
      title={t('userAccessControl.details.title')}
      onBack={() => navigate({ pathname: userAccessRoutes.root, search: location.search }, { state: location.state })}
    />
  );

  if (detailsQuery.isError && !details) {
    return <UserAccessErrorState header={header} onRetry={() => void detailsQuery.refetch()} />;
  }

  if (detailsQuery.isLoading || !details) {
    return <UserAccessLoadingState header={header} />;
  }

  return <UserDetailsContent userId={userId} user={details} header={header} />;
}
